module.exports = function() {
  return new Worker(__webpack_public_path__ + "dbe0cee87adc9fd2f5a4.worker.js");
};